import React from "react";

interface FootnoteListProps {
  notes: { id: string | number; text: React.ReactNode }[];
  className?: string;
}

/**
 * Resolves footnote anchors emitted by Stat / inline `<sup>` markers.
 * Anchor format: `<a href="#fn-1">1</a>` → resolved to `<li id="fn-1">…</li>`.
 */
export function FootnoteList({ notes, className = "" }: FootnoteListProps) {
  if (!notes.length) return null;
  return (
    <aside
      className={`mt-12 pt-6 border-t border-latte-300 dark:border-latte-800 ${className}`}
      aria-label="Footnotes"
    >
      <ol className="space-y-2 text-caption text-coffee-700 dark:text-cream-200">
        {notes.map((note) => (
          <li
            key={note.id}
            id={`fn-${note.id}`}
            className="flex gap-3"
          >
            <span className="font-mono text-accent-500 shrink-0">{note.id}.</span>
            <span>{note.text}</span>
          </li>
        ))}
      </ol>
    </aside>
  );
}

export default FootnoteList;
